(function () {
  var STORAGE_KEY = 'vlazura_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function saveWishlist(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }
    catch (e) {}
  }

  function initWishlist() {
    var wishlist = getWishlist();
    document.querySelectorAll('.vlazura-wishlist').forEach(function (btn) {
      var id = btn.dataset.productId;
      if (wishlist.indexOf(id) > -1) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
      }
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var list = getWishlist();
        var idx = list.indexOf(id);
        if (idx > -1) {
          list.splice(idx, 1);
          btn.classList.remove('is-active');
          btn.setAttribute('aria-pressed', 'false');
        } else {
          list.push(id);
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
        }
        saveWishlist(list);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlist);
  } else {
    initWishlist();
  }
})();
